import differenceInDays from 'date-fns/differenceInDays';
import _round from 'lodash/round';

import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';

export default function getTimeAgo(time?: string | number) {
  if (!time) {
    return null;
  }

  const currentDate = new Date();
  const timeStamp = new Date(time);

  const days = _round(differenceInDays(currentDate, timeStamp.valueOf()));
  const weeks = _round(days / 7);
  const months = _round(days / 30);
  const years = _round(days / 365);

  if (years >= 1) {
    return `${years} y`;
  }

  if (months > 1) {
    return `${months} months`;
  }

  if (months === 1) {
    return `${months} month`;
  }

  if (weeks >= 1) {
    return `${weeks} w`;
  }

  if (days >= 1) {
    return `${days} d`;
  }

  return formatDate(timeStamp, DateFormat.Time);
}
